import styled from 'styled-components';
import { assetTheme as t } from './assetTheme';

// Small action chip revealed on hover (Copy URL / rename / delete)
export default styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 30px;
  min-width: 30px;
  padding: 0 9px;
  border-radius: 8px;
  font-family: ${t.fontFamily};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  border: ${({ $variant }) => $variant === 'light' ? `1px solid ${t.borderStrong}` : 'none'};
  background: ${({ $variant }) =>
    $variant === 'copy' ? t.action :
    $variant === 'dark' ? t.midnight :
    '#ffffff'};
  color: ${({ $variant }) => ($variant === 'copy' || $variant === 'dark') ? '#ffffff' : t.text};
  box-shadow: ${({ $flat }) => $flat ? 'none' : '0 2px 8px rgba(0,19,35,.18)'};

  &:hover {
    filter: brightness(1.1);
  }
`
